import { useState } from "react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({ label, options, value, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <label className="text-xs uppercase tracking-wider text-charcoal mb-2 block">
        {label}
      </label>

      <div
        onClick={() => setOpen(!open)}
        className="border border-[#E5E0D8] rounded-lg px-4 py-3 cursor-pointer flex justify-between items-center hover:border-[#ba8245]"
      >
        <span className={value ? "text-black" : "text-gray-400"}>
          {value || "Select"}
        </span>
        <ChevronDown size={18} className="text-gray-400" />
      </div>

      {open && (
        <div className="absolute w-full mt-2 bg-white border border-[#EAE4DC] rounded-lg shadow-lg z-10">
          {options.map((opt, i) => (
            <div
              key={i}
              onClick={() => {
                onChange(opt);
                setOpen(false);
              }}
              className="px-4 py-3 hover:bg-[#f8f6f2] cursor-pointer text-sm"
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;